<template>
  <!-- Page Content -->
  <div class="whole-page-long" id="whole-page-div">
    <div class="navbar-div">
      <NavbarComponent
        :colorTheme="colorTheme"
        :selectedNavLink="null"
        :user="user"
        analysis="HEDGE"
        @eventOnUserSelectNavLink="eventOnClientSelectAsset"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>
    <div
      class="justify-content-center vert-align accordion-div"
      v-if="false"
      style="top: 60px!important; height: calc(100% - 60px)!important;"
    >
      <div class="col col-12 text-center inh">
        Coming soon...
      </div>
    </div>
    <OverallProcess
      :colorTheme="colorTheme"
      :processStage="processStage"
      :readyToTrade="readyToTrade"
      :valuated="valuated"
    />

    <div class="modal-upload-expo" v-show="showModalCancelPreQuote">
      <div class="inside-modal-cancel">
        <CancelQuoteModal
          :colorTheme="colorTheme"
          @eventOnUserStopQuote="onUserStopQuote"
          @eventOnUserContinueQuote="onUserContinueQuote"
        />
      </div>
    </div>

    <div class="modal-upload-expo" v-show="showModalQuote">
      <div class="inside-modal">
        <QuoteTradeInputs
          :averages="averages"
          :banks="banks"
          :baseCurrency="baseCurrency"
          :colorTheme="colorTheme"
          :companies="companies"
          :currencySpecs="currencySpecs"
          :isFwdOrFuture="isFwdOrFuture"
          :notional="notional"
          :orderType="orderType"
          :position="position"
          :quoteObjective="quoteObjective"
          :quoteTrade="quoteTrade"
          :refUserData="refUserData"
          :selectedAsset="selectedAsset"
          :selectedCompany="selectedCompany"
          :selectedCurrency="currencySpecs[selectedAsset].currency_name"
          :selectedLegQuote="selectedLegQuote"
          :showLoadingSpot="showLoadingSpot"
          :spot="spot"
          :strategies="strategies"
          :strategyCost="strategyCost"
          :strategyLegs="strategyLegs"
          :strategyName="strategies[0].name"
          :userNewHedge="userNewHedge"
          @eventOnUserCompanySelection="onUserCompanySelection"
          @eventOnUserSpotChange="onUserSpotChange"
          @eventOnUserSpotRefresh="onUserSpotRefresh"
          @eventOnUserCostChange="onUserCostChange"
          @eventOnUserOrderChange="onUserOrderChange"
          @eventOnUserOrderCostOrStrike="onUserOrderCostOrStrike"
          @eventOnClientLegSelect="onClientLegSelect"
          @eventOnClientBankInclude="onClientBankInclude"
          @eventOnUserCancelQuote="onUserCancelQuote"
          @eventOnUserQuote="onUserQuote"
        />
      </div>
    </div>

    <SelectStrategiesModal
      v-show="showAllStrats"
      :strategiesOrdered="strategiesOrdered"
      @eventOnUserIncludeStrat="onUserIncludeStrat"
      @eventOnUserCancelStrat="onUserCancelStrat"
    />

    <div class="row f-row bdr-b" style="height: calc(30vh - 50px)!important;">
      <div class="col col-12 text-center mb-2 h-100">
        <QuoteProcessTable
          :banks="banks"
          :colorTheme="colorTheme"
          :processStage="processStage"
          :quoteElapsed="quoteElapsed"
          :readyToQuote="
            valuated && !showLoadingValInputs && !showLoadingCalculating
          "
          :readyToTrade="readyToTrade"
          :selectedBank="selectedBank"
          @eventOnClientBankSelect="onClientBankSelect"
          @eventOnClientBankInclude="onClientBankInclude"
          @eventOnUserPreQuote="onUserPreQuote"
          @eventOnUserCancelPreQuote="onUserCancelPreQuote"
        />
      </div>
    </div>

    <div
      class="row f-row"
      v-if="processStage === 0"
      style="height: calc(70vh - 50px)!important;"
    >
      <div class="col col-6 text-center">
        <DateNotional
          :strategies="strategies"
          :strategyLegs="strategyLegs"
          :userNewHedge="userNewHedge"
          :averages="averages"
          :selectedAsset="selectedAsset"
          :currencySpecs="currencySpecs"
          :position="position"
          :notional="notional"
          :initialDate="initialTableDate"
          :nDates="nDates"
          :frequency="frequency"
          :frequencyOptions="frequencyOptions"
          :getCountriesPair="getCountriesPair"
          @eventOnUserTableChange="onUserTableChange"
          @eventOnUserFrequencySelection="onUserFrequencySelection"
          @eventOnUserAssetSelection="onUserAssetSelection"
          @eventOnUserPositionChange="onUserPositionChange"
          @eventOnUserNotionalChange="onUserNotionalChange"
          @eventOnUserDateChange="onUserDateChange"
          @eventOnUserNDatesChange="onUserNDatesChange"
          @eventUpdateNDates="updateNDates"
        />
      </div>
      <div class="col col-6 text-center">
        <div
          class="row f-row mt-1 mb-1 justify-content-center"
          style="vertical-align: middle!important;"
        >
          <div class="col col-auto txt-label-primary-2 text-right">
            <span class="mr-1">SPOT:</span>
            <span v-if="showLoadingSpot" class="mr-1">
              <v-progress-circular
                indeterminate
                :size="14"
                :width="1.5"
                color="primary"
              ></v-progress-circular>
            </span>
          </div>
          <div class="col col-2 txt-label-primary-2 text-center">
            <input
              v-model.number.lazy="spot"
              placeholder="spot"
              class="custom-input input-sm"
              @change="onUserSpotChange(spot)"
            />
          </div>
          <div class="col col-auto txt-label-primary-2 text-center">
            <button class="btn updateSpot" v-on:click="onUserSpotRefresh">
              <i class="fa fa-refresh"></i>
            </button>
          </div>
          <div class="col col-1"></div>
          <div class="col col-auto txt-label-primary-2 text-right">
            <span class="mr-1">CLICK TO CHANGE:</span>
          </div>
          <div class="col col-auto txt-label-primary-2 text-center h-100">
            <span style="width: 100%; height: 100%; padding: 5px 0 0 0;">
              <input
                type="button"
                id="strat"
                class="inputFileBlue"
                @click="onUserSelectStrategies"
              />
              <label for="strat">
                <span class="ml-3 mr-3">{{ strategies[0].name }}</span>
              </label>
            </span>
          </div>
          <div
            class="col col-auto txt-label-primary-2 text-center"
            v-show="warnStrategy"
          >
            <i
              class="fa fa-warning warn-my-data ml-2"
              @mouseover="onHoverWarning(true)"
              @mouseleave="onHoverWarning(false)"
            ></i>
          </div>
          <div class="warning-trade-div text-center" v-if="showWarningDiv">
            {{ position === "buy" ? "Buying" : "Selling" }}
            {{
              this.currencySpecs[this.selectedAsset].currency_name.slice(0, 3)
            }}, check strategy selection
          </div>
        </div>
        <div
          class="row f-row"
          v-if="!valuated"
          style="height: calc(70vh - 102px)!important;"
        >
          <div
            class="col col-12 text-center h-100"
            style="background: var(--lightbackground-alpha3);"
          >
            <div style="width: 100%; height: calc(50% - 70px)"></div>
            <span v-if="valuating">
              CALCULATING
              <v-progress-circular
                indeterminate
                :size="14"
                :width="1.5"
                color="primary"
              ></v-progress-circular>
              <br />
            </span>
            <button
              v-else-if="!valuated"
              type="button"
              class="btn btn-strat-blue"
              style="width: 75%!important; height: 70px; font-size: 1rem;"
              v-on:click="onUserValuate"
            >
              CALCULATE STRATEGY VALUES
            </button>
          </div>
        </div>
        <div
          class="row f-row"
          v-if="valuated"
          style="height: calc(70vh - 102px)!important;"
        >
          <StrategiesDesigner
            :adjustTooltip="true"
            :baseCurrency="baseCurrency"
            :colorTheme="colorTheme"
            :dataSliced="dataSliced"
            :hedgeData="hedgeData"
            :historicalData="historicalData"
            :minMaxYAxisRates="minMaxYAxisRates"
            :renderCharts="renderCharts"
            :selectedAssetLink="selectedAssetLink"
            :showLCall="showLCall"
            :showLFwd="showLFwd"
            :showLoading="
              showLoadingValInputs || showLoadingCalculating || showLoadingSpot
            "
            :showLoadingHistCandles="showLoadingHistCandles || showLoadingSpot"
            :showLPut="showLPut"
            :showOHL="false"
            :showSCall="showSCall"
            :showSFwd="showSFwd"
            :showSPut="showSPut"
            :showTitles="false"
            :strategies="strategies"
            :xRange="xRange"
            @eventOnShow="onShow"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CancelQuoteModal from "@/components/hedge/CancelQuoteModal";
import DateNotional from "@/components/hedge/DateNotional";
import NavbarComponent from "@/components/Navbar.vue";
import OverallProcess from "@/components/hedge/OverallProcess";
import QuoteTradeInputs from "@/components/hedge/QuoteTradeInputs";
import QuoteProcessTable from "@/components/hedge/QuoteProcessTable";
import SelectStrategiesModal from "@/components/optimizer/SelectStrategiesModal";
import StrategiesDesigner from "@/components/optimizer/StrategiesDesigner";
import { ProcessData } from "@/_core/data/ProcessData";
import {
  additionalYSpace,
  assetSelectionVuex,
  colorThemeChange,
  colorThemeVuex,
  date2Str,
  formatDate_DDMMMYHMS,
  rankArray,
} from "@/_core/_helpers/_helpers";
import {
  createSelectedHedge,
  filterCurrenciesWithValuationData,
  getCountriesPair,
  holidaysCorrection,
  includeStrategy,
  initializeStrategiesRProfile,
  OptimizerManager,
  setBaseCurrency,
  step1to2Currency,
} from "@/_core/data/Optimizer";
import { getInitialStrategyValues } from "@/_core/data/api_calls/getInitialStrategyValues";
import { getStrategiesData } from "@/_core/data/api_calls/getStrategiesData";
import { getSpotData } from "@/_core/data/api_calls/getSpotData";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { getCurrencyCounterparties } from "@/_core/data/api_calls/getCurrencyCounterparties";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { mean, sum, timeParse } from "d3";

export default {
  name: "Hedge",
  components: {
    CancelQuoteModal,
    DateNotional,
    NavbarComponent,
    OverallProcess,
    QuoteTradeInputs,
    QuoteProcessTable,
    SelectStrategiesModal,
    StrategiesDesigner,
  },
  data() {
    return {
      averages: [],
      banks: [],
      baseCurrency: {
        rate: "N.A.",
        foreign: "N.A.",
        base: "N.A.",
        changeBase: "N.A.",
      },
      colorTheme: true,
      companies: [],
      countrySpecs: [],
      currencyNumber: 11,
      currencySpecs: [],
      currencyString: null,
      dataSliced: [],
      faildGetHistoricalData: false,
      finalDate: new Date(),
      frequency: "M",
      frequencyOptions: [
        { text: "DAILY", value: "D" },
        { text: "WEEKLY", value: "W" },
        { text: "HALF-MONTH", value: "2W" },
        { text: "MONTHLY", value: "M" },
        { text: "QUARTERLY", value: "Q" },
        { text: "SEMESTER", value: "S" },
        { text: "YEARLY", value: "Y" },
      ],
      getCountriesPair: getCountriesPair,
      hedge_preferences: {},
      hedgeData: [],
      hedgeDataSliced: [],
      hedgeTemplate: [],
      historicalData: [],
      historicalOHLC: { open: 0, high: 0, low: 0, close: 0 },
      initCurrencyDate: new Date(
        new Date().setMonth(new Date().getMonth() - 6),
      ),
      initialDate: new Date(new Date().setDate(new Date().getDate() + 1)),
      initialTableDate: date2Str(
        new Date(new Date().setMonth(new Date().getMonth() + 1)),
        0,
      ),
      keys: [],
      longStrats: [],
      minMaxYAxisHist: [+Infinity, -Infinity],
      minMaxYAxisRates: [+Infinity, -Infinity],
      nDates: 6,
      notional: 100000,
      orderType: "market",
      position: "buy",
      prevHedgeTemplate: [],
      processData: null,
      processStage: 0, // 0 = select strategy, 1 = quoting, 2 = quotes received & compare, 3 = hedge
      quoteElapsed: null,
      quoteInterval: null,
      quoteObjective: "strike", // TODO: quitar de todos lados
      quoteRanking: [],
      quoteStartTime: null,
      quoteTrade: "QUOTE",
      refUserData: [],
      renderCharts: 0,
      root: document.documentElement,
      selectedAsset: 0,
      selectedAssetLink: 0,
      selectedBank: -1,
      selectedCompany: 0,
      selectedCurrency: 0,
      selectedLegQuote: [0],
      selectedRiskProfile: 0,
      selectedTabNotional: 0,
      shortStrats: [],
      showAllStrats: false,
      showLCall: true,
      showLFwd: true,
      showLoadingBanks: true,
      showLoadingHistCandles: true,
      showLoadingSpot: true,
      showLoadingStrategies: true,
      showLoadingValInputs: false,
      showLPut: true,
      showModalCancelPreQuote: false,
      showModalQuote: false,
      showSCall: true,
      showSFwd: true,
      showSPut: true,
      showWarningDiv: false,
      spot: null,
      strategies: [
        {
          pk: 1,
          numLegs: 1,
          data: [],
          simulations: [],
          id: 0,
          fixedCost: true,
          objectiveLeg: 1,
          first_second_strike_equal: false,
          name: "LONG FORWARD",
          rProfile: 2,
          rProfileBuyer: 2,
          rProfileSeller: 4,
          leg1: "+FORWARD",
          leg2: null,
          leg3: null,
          leg4: null,
          isStrip1: false,
          isStrip2: false,
          isStrip3: false,
          isStrip4: false,
          derivative1: 1,
          derivative2: 1,
          derivative3: 1,
          derivative4: 1,
          strike1: 0,
          strike2: 0,
          strike3: 0,
          strike4: 0,
          barrier1: 0,
          barrier2: 0,
          barrier3: 0,
          barrier4: 0,
          barrier1_2: 0,
          barrier2_2: 0,
          barrier3_2: 0,
          barrier4_2: 0,
          cost: null,
          costPerc: 0,
          active: true,
          percentage: 100,
          show: true,
          showLoading: false,
          calculated: false,
          simulated: false,
          warning: null,
        },
      ],
      strategiesList: [],
      strategiesOrdered: [],
      strategyCost: 0,
      strategyLegs: [],
      strategyListByPK: {},
      todayDate: timeParse("%Y-%m-%d")(date2Str(new Date(), 0)),
      user: {},
      userCosts: { fwd: 0.001, volSpread: 0.0025, mu: 0.001 },
      userNewHedge: [],
      valuateAfterSpot: false,
      valuated: false,
      valuating: false,
      valuationDataRaw: [],
      xRange: [],
    };
  },
  created() {
    getCurrencyCounterparties(this, "banks", "showLoadingBanks");
    this.hedge_preferences = this.$store.state.user_preferences.all.items.hedges_choices;
    try {
      this.colorTheme = this.hedge_preferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }
    this.processData = new ProcessData();
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
    } catch (error) {
      console.log(`Error currencies ${error}`);
    }
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
      // TODO: esto deberia ser para todas las monedas
      this.currencySpecs = filterCurrenciesWithValuationData(
        this.currencySpecs,
      );
    } catch (error) {
      console.log(`Error countries ${error}`);
    }

    this.currencyString = this.currencySpecs[
      this.selectedCurrency
    ].currency_name;
    this.currencyNumber = this.currencySpecs.filter(
      (curr) => curr.currency_name === this.currencyString,
    )[0].pk_i_idcurrency;
    setBaseCurrency(this);
    getStrategiesData(this, "strategiesList", "showLoadingStrategies");
    getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) => {
      this["spot"] = data[0].last;
      this["updatedAt"] =
        "Updated at: " + formatDate_DDMMMYHMS(data[0].observation_time);
      this["showLoadingSpot"] = false;
    });
    getCandleData(this, "currency")
      .then((data) => {
        this["historicalData"] = data;
        this["historicalOHLC"] = JSON.parse(
          JSON.stringify(data[data.length - 1]),
        );
        this["historicalOHLC"].open = +this["historicalOHLC"].open;
        this["historicalOHLC"].high = +this["historicalOHLC"].high;
        this["historicalOHLC"].low = +this["historicalOHLC"].low;
        this["historicalOHLC"].close = +this["historicalOHLC"].close;
        this["showLoadingHistCandles"] = false;
      })
      .catch(function(error) {
        this["showLoadingHistCandles"] = false;
        this["historicalData"] = [];
        console.log(error);
      });
    this.optimizerManager = new OptimizerManager(this.selectedAssetLink, this);

    document.title = "Hedge | Quanspire";
  },
  mounted() {
    this.userNewHedge = createSelectedHedge(
      this.initialTableDate,
      this.notional,
      this.nDates,
      this.frequency,
    );
    holidaysCorrection(this);
    this.fillUserNewHedge();
    this.refUserData = this.userNewHedge;
    this.getAverages();
  },
  computed: {
    isFwdOrFuture() {
      return (
        this.strategies[0].name === "LONG FORWARD" ||
        this.strategies[0].name === "SHORT FORWARD" ||
        this.strategies[0].name === "LONG FUTURE" ||
        this.strategies[0].name === "SHORT FUTURE"
      );
    },
    allQuotesReceived() {
      let allQ = true;
      this.banks.forEach(function(d) {
        if (d.value === null && d.state !== -1) {
          allQ = false;
        }
      });
      return allQ;
    },
    readyToTrade() {
      if (this.selectedBank < 0 || this.selectedBank > this.banks.length - 1) {
        return false;
      }
      let readyT = false;
      this.banks.forEach(function(d) {
        if (d.value != null) {
          readyT = true;
        }
      });
      return readyT;
    },
    bankVals() {
      return mean(this.banks, function(d) {
        return d.value !== null ? d.value : 0;
      });
    },
    showLoadingCalculating() {
      return this.strategies[0].showLoading;
    },
    selectedPosition() {
      return this.position === "buy" ? 1 : -1;
    },
    warnStrategy() {
      let res;
      if (this.position === "buy") {
        res = this.shortStrats.includes(this.strategies[0].name);
      } else {
        res = this.longStrats.includes(this.strategies[0].name);
      }
      return res;
    },
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.hedge_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    onClientBankInclude(val) {
      this.banks = val;
    },
    onClientBankSelect(idx) {
      this.selectedBank = idx;
    },
    getAverages() {
      let ks = Object.keys(this.userNewHedge[0]);
      this.keys = ks.filter((d) => d !== "date" && d !== "newHedge");
      this.averages = [];
      let i, ave;
      let _this = this;
      for (i = 0; i < _this.keys.length; i++) {
        ave =
          sum(_this.userNewHedge, function(d) {
            return d.newHedge * d[_this.keys[i]];
          }) /
          sum(this.userNewHedge, function(d) {
            return d.newHedge;
          });
        _this.averages.push(ave);
      }
      this.strategyCost = -sum(_this.strategies[0].data, function(d) {
        return d.premium;
      });
    },
    onUserValuate() {
      this.hedgeData = [];
      if (this.valuated === false) {
        step1to2Currency(this); // build hedgeTemplate
        this.showLoadingValInputs = true;
        this.optimizerManager.buildJsonStepOne();
        this.valuated = true;
      } else {
        this.strategies[0].showLoading = true;
        getInitialStrategyValues(
          this,
          this.strategiesList[this.strategyListByPK[this.strategies[0].pk]],
          0,
          this.selectedAssetLink === 0 ? "currencies" : "commodities",
        );
      }
    },
    getStrategyLegs() {
      let legs = [this.strategies[0].leg1];
      if (this.strategies[0].numLegs >= 2) {
        legs = legs.concat([this.strategies[0].leg2]);
      }
      if (this.strategies[0].numLegs >= 3) {
        legs = legs.concat([this.strategies[0].leg3]);
      }
      if (this.strategies[0].numLegs >= 4) {
        legs = legs.concat([this.strategies[0].leg4]);
      }
      legs = legs.concat(["premium"]);
      return legs;
    },
    eventOnClientSelectAsset(idx) {
      this.selectedAssetLink = idx;
      this.hedge_preferences.selected_nav = idx;
      assetSelectionVuex(this, this.selectedNavLink);
      this.$store.state.user_preferences.all.items.hedges_choices = this.hedge_preferences;
      saveUserPreferences(this);
    },
    onUserCompanySelection(val) {
      this.selectedCompany = val;
    },
    onUserSpotChange(val) {
      this.spot = val;
      this.historicalData = this.processData.includeSpot(
        this.historicalData,
        this.spot,
      );
      this.optimizerManager.mergeOnSpotChange(this);
      this.onUserValuate();
      this.renderCharts += 1;
    },
    onUserSpotRefresh() {
      this.valuateAfterSpot = true;
      this.showLoadingSpot = true;
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) => {
        this["spot"] = data[0].last;
        this["updatedAt"] =
          "Updated at: " + formatDate_DDMMMYHMS(data[0].observation_time);
        this["showLoadingSpot"] = false;
      });
      this.valuated = false;
    },
    onUserCostChange(val) {
      this.strategyCost = val;
    },
    onUserOrderChange(val) {
      this.orderType = val;
    },
    onUserOrderCostOrStrike(val) {
      this.quoteObjective = val;
    },
    onClientLegSelect(val) {
      this.selectedLegQuote = val;
    },
    onUserPreQuote(val) {
      this.quoteTrade = val;
      this.showModalQuote = true;
    },
    onUserCancelPreQuote() {
      this.showModalCancelPreQuote = true;
    },
    onUserStopQuote() {
      this.selectedBank = -1;
      this.processStage = 0;
      this.banks.forEach(function(d) {
        d.state = 0;
        d.quote = [];
        d.value = null;
        d.rank = null;
      });
      clearInterval(this.quoteInterval);
      this.showModalCancelPreQuote = false;
    },
    onUserContinueQuote() {
      this.showModalCancelPreQuote = false;
    },
    onUserCancelQuote() {
      this.showModalQuote = false;
    },
    onUserQuote() {
      this.showModalQuote = false;
      this.processStage = 1;
      this.simulateQuote();
    },
    addOneToState(idx) {
      let row = this.banks[idx];
      row.state += 1;
      this.banks.splice(idx, 1, row);
    },
    simulateQuote() {
      let _this = this;
      let i, k, j, row;
      let nLen = this.banks.length;
      for (i = 0; i < nLen - 1; i++) {
        j = 0;
        for (k = 0; k < 3; k++) {
          (function(idx, j) {
            setTimeout(function() {
              _this.addOneToState(idx);
              if (idx === 0 && j === 0) {
                _this.banks[nLen - 1].state = 1;
              }
              if (_this.banks[idx].state >= 3) {
                _this.banks[idx].value = Math.random();
                row = _this.banks[nLen - 1];
                row.state = -1;
                _this.banks.splice(nLen - 1, 1, row);
              }
            }, Math.round(5000 * Math.random() * j + 5000 * k));
          })(i, j);
          j += 1;
        }
      }
    },
    // ========== DateNotional.vue =========
    onUserTableChange(data) {
      this.userNewHedge = data;
      this.fillUserNewHedge();
      this.refUserData = this.userNewHedge;
      this.getAverages();
      this.valuated = false;
    },
    onUserFrequencySelection(freq) {
      this.frequency = freq;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
      this.fillUserNewHedge();
      this.refUserData = this.userNewHedge;
      this.getAverages();
      this.valuated = false;
    },
    onUserAssetSelection(asset) {
      this.valuated = false;
      this.hedgeData = [];
      this.selectedCurrency = asset;
      this.currencyString = this.currencySpecs[
        this.selectedCurrency
      ].currency_name;
      this.currencyNumber = this.currencySpecs.filter(
        (curr) => curr.currency_name === this.currencyString,
      )[0].pk_i_idcurrency;
      setBaseCurrency(this);
      this.minMaxYAxisHist = [+Infinity, -Infinity];
      this.minMaxYAxisRates = [+Infinity, -Infinity];
      getSpotData(this, "spot", "updatedAt", "showLoadingSpot").then((data) => {
        this["spot"] = data[0].last;
        this["updatedAt"] =
          "Updated at: " + formatDate_DDMMMYHMS(data[0].observation_time);
        this["showLoadingSpot"] = false;
      });
      getCandleData(this, "currency")
        .then((data) => {
          this["historicalData"] = data;
          this["historicalOHLC"] = JSON.parse(
            JSON.stringify(data[data.length - 1]),
          );
          this["historicalOHLC"].open = +this["historicalOHLC"].open;
          this["historicalOHLC"].high = +this["historicalOHLC"].high;
          this["historicalOHLC"].low = +this["historicalOHLC"].low;
          this["historicalOHLC"].close = +this["historicalOHLC"].close;
          this["showLoadingHistCandles"] = false;
        })
        .catch(function(error) {
          this["showLoadingHistCandles"] = false;
          this["historicalData"] = [];
          console.log(error);
        });
      this.xRange = this.dataSliced.map((d) => d.date);
      step1to2Currency(this);
      this.optimizerManager.buildJsonStepOne();
    },
    fillUserNewHedge() {
      this.strategyLegs = this.getStrategyLegs();
      let legs = this.strategyLegs;
      let i;
      this.userNewHedge.forEach(function(d) {
        d.fwd = 0;
        for (i = 0; i < legs.length - 1; i++) {
          d["leg" + (i + 1)] = 0;
        }
        d.premium = 0;
      });
    },
    onUserPositionChange(position) {
      this.position = position;
    },
    onUserNotionalChange(notional) {
      this.notional = notional;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
      this.fillUserNewHedge();
      this.refUserData = this.userNewHedge;
      this.getAverages();
      this.valuated = false;
    },
    onUserDateChange(dat) {
      this.initialTableDate = dat;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
      this.fillUserNewHedge();
      this.refUserData = this.userNewHedge;
      this.getAverages();
      this.valuated = false;
    },
    onUserNDatesChange(nDate) {
      this.nDates = nDate;
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      holidaysCorrection(this);
      this.fillUserNewHedge();
      this.refUserData = this.userNewHedge;
      this.getAverages();
      this.valuated = false;
    },
    updateNDates(nDate) {
      this.nDates = nDate;
      this.valuated = false;
    },
    onUserSelectStrategies() {
      this.showAllStrats = true;
    },
    // ========== helpers =========
    onShow(val) {
      if (val === 5) {
        this.showLFwd = !this.showLFwd;
      } else if (val === 6) {
        this.showSFwd = !this.showSFwd;
      } else if (val === 7) {
        this.showLCall = !this.showLCall;
      } else if (val === 8) {
        this.showSCall = !this.showSCall;
      } else if (val === 9) {
        this.showLPut = !this.showLPut;
      } else if (val === 10) {
        this.showSPut = !this.showSPut;
      }
      this.minMaxYAxisRates = this.processData.minMax(
        this.hedgeData,
        "strike",
        "strike",
        [this.minMaxYAxisHist[0], this.minMaxYAxisHist[1]],
      );
      this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
      this.renderCharts += 1;
    },
    onUserIncludeStrat(item) {
      this.hedgeData = [];
      this.strategies = [];
      includeStrategy(this, item, this.selectedPosition);
      let nLegs = this.strategies[0].numLegs;
      if (this.strategies[0].first_second_strike_equal && nLegs <= 2) {
        this.selectedLegQuote = [0, 1];
      } else {
        this.selectedLegQuote = [nLegs - 1];
      }
      this.userNewHedge = [];
      this.userNewHedge = createSelectedHedge(
        this.initialTableDate,
        this.notional,
        this.nDates,
        this.frequency,
      );
      this.strategyLegs = this.getStrategyLegs();
      this.fillUserNewHedge();
      this.refUserData = this.userNewHedge;
      this.getAverages();
      this.showAllStrats = false;
      this.onUserValuate();
    },
    onUserCancelStrat() {
      this.showAllStrats = false;
    },
    onHoverWarning(val) {
      this.showWarningDiv = val;
    },
  },
  watch: {
    allQuotesReceived(val) {
      if (val === true) {
        this.processStage = 2;
      }
    },
    processStage(val) {
      if (val === 0) {
        clearInterval(this.quoteInterval);
      } else if (val === 1) {
        let _this = this;
        this.quoteStartTime = new Date();
        this.quoteInterval = setInterval(() => {
          _this.quoteElapsed = new Date(new Date() - _this.quoteStartTime)
            .toISOString()
            .substr(11, 8);
        }, 1000);
      } else if (val === 2) {
        clearInterval(this.quoteInterval);
      }
    },
    bankVals(val) {
      if (val !== undefined) {
        this.quoteRanking = rankArray(this.banks.map((d) => d.value));
        if (val.length !== 0 && this.banks.length !== 0) {
          let i;
          let nLen = +JSON.parse(JSON.stringify(this.banks.length));
          for (i = 0; i < nLen; i++) {
            let row = this.banks[i];
            row.rank = this.quoteRanking[i];
            this.banks.splice(i, 1, row);
          }
        }
      }
    },
    showLoadingCalculating(val) {
      if (val === false) {
        let _this = this;
        let jRem, leg;
        let len = this.userNewHedge.length;
        console.log(this.hedgeData);
        this.hedgeData.forEach(function(d, j) {
          jRem = j % len;
          leg = d.leg;
          if (leg === 1) {
            _this.userNewHedge[jRem].fwd = d.fwd;
            _this.userNewHedge[jRem]["premium"] = d.premium;
          } else {
            _this.userNewHedge[jRem]["premium"] += d.premium;
          }
          _this.userNewHedge[jRem]["leg" + leg] = d.strike;
        });
        this.getAverages();
        this.refUserData = this.userNewHedge;
        console.log(_this.userNewHedge);
      }
    },
    showLoadingValInputs(val) {
      if (val === false) {
        this.strategies[0].showLoading = true;
        getInitialStrategyValues(
          this,
          this.strategiesList[this.strategyListByPK[this.strategies[0].pk]],
          0,
          this.selectedAssetLink === 0 ? "currencies" : "commodities",
        );
      }
    },
    showLoadingHistCandles(val) {
      if (val === false) {
        if (this.showLoadingSpot === false) {
          this.historicalData = this.processData.includeSpot(
            this.historicalData,
            this.spot,
          );
        }
        this.historicalData = this.processData.ohlcNest(
          this.historicalData,
          "week",
        );
        this.minMaxYAxisHist = this.processData.minMax(
          this.historicalData,
          "high",
          "low",
        );
        this.minMaxYAxisHist = this.processData.minMax(
          this.dataSliced,
          "m2m_rate",
          "m2m_rate",
          this.minMaxYAxisHist,
        );
        this.minMaxYAxisRates = [
          this.minMaxYAxisHist[0],
          this.minMaxYAxisHist[1],
        ];
        this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
        this.renderCharts += 1;
      }
    },
    showLoadingSpot(val) {
      if (val === false) {
        if (this.valuateAfterSpot === true) {
          this.onUserValuate();
        }
        if (this.showLoadingHistCandles === false) {
          this.historicalData = this.processData.includeSpot(
            this.historicalData,
            this.spot,
          );
        }
        this.historicalData = this.processData.ohlcNest(
          this.historicalData,
          "week",
        );
        this.minMaxYAxisHist = this.processData.minMax(
          this.historicalData,
          "high",
          "low",
        );
        this.minMaxYAxisHist = this.processData.minMax(
          this.dataSliced,
          "m2m_rate",
          "m2m_rate",
          this.minMaxYAxisHist,
        );
        this.minMaxYAxisRates = [
          this.minMaxYAxisHist[0],
          this.minMaxYAxisHist[1],
        ];
        this.minMaxYAxisRates = additionalYSpace(this.minMaxYAxisRates, 0.05);
        this.renderCharts += 1;
      }
    },
    showLoadingStrategies(val) {
      if (val === false) {
        let _this = this;
        this.strategiesOrdered = [];
        let longS = [],
          shortS = [],
          volS = [];
        this.strategyListByPK = {};
        this.strategiesList.forEach(function(d, i) {
          _this.strategyListByPK[d.pk_idcurrencystrategy] = i;
        });
        this.strategiesList.forEach(function(d) {
          if (d.undelying_position === -1) {
            longS.push(d);
          } else if (d.undelying_position === 1) {
            shortS.push(d);
          } else {
            volS.push(d);
          }
        });
        this.longStrats = longS.map((d) => d.name);
        this.shortStrats = shortS.map((d) => d.name);
        this.strategiesOrdered = { long: longS, short: shortS, vol: volS };
        initializeStrategiesRProfile(this, true);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.quoteInterval);
  },
};
</script>

<style scoped></style>
